import React, { Component } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Assets
import stepBg1 from "../../Assets/StepBg1.svg";
import stepBg2 from "../../Assets/StepBg2.svg";
import stepBg3 from "../../Assets/StepBg3.svg";

export default class FollowStep extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    AOS.init({
      offset: 100,
      duration: 1000,
      easing: "ease-in-quad",
    });
  }

  render() {
    return (
      <div className="Home_Steps">
        <div className="Home_StepsTitle">
          Get Start By Following These Easy Steps
        </div>
        <div className="Home_StepsCardBlock">
          <div className="emptyDiv" style={{ justifyContent: "flex-start" }}>
            <div
              id="1"
              className="Home_Cards"
              style={{ borderRadius: "0px 20px 0px 20px" }}
              // data-aos="fade-left"
            >
              <div className="Home_CardContent">
                <div className="Home_CardTitle">Step1</div>
                <div className="Home_CardDesc">
                  Initially enter your pre-blood glucose level which you have
                  got in respected period
                </div>
              </div>
              <div className="Home_CardImg">
                <img src={stepBg1} />
              </div>
            </div>
          </div>

          <div className="emptyDiv" style={{ justifyContent: "flex-end" }}>
            <div
              id="2"
              className="Home_Cards"
              style={{ borderRadius: "20px 0px 20px 0px" }}
              // data-aos="fade-right"
              // data-aos-delay="300"
            >
              <div className="Home_CardContent">
                <div className="Home_CardTitle">Step2</div>
                <div className="Home_CardDesc">
                  We will suggest low carbs food which you can select as meal as
                  well as you can also select your favorite food.
                </div>
              </div>
              <div className="Home_CardImg">
                <img src={stepBg2} />
              </div>
            </div>
          </div>

          <div className="emptyDiv" style={{ justifyContent: "flex-start" }}>
            <div
              id="3"
              className="Home_Cards"
              style={{ borderRadius: "0px 20px 0px 20px" }}
            >
              <div className="Home_CardContent">
                <div className="Home_CardTitle">Step3</div>
                <div className="Home_CardDesc">
                  Depending upon the meal selected we will suggest you insulin
                  intake for that meal.
                </div>
              </div>
              <div className="Home_CardImg">
                <img src={stepBg3} />
              </div>
            </div>
          </div>

          <div className="emptyDiv" style={{ justifyContent: "flex-end" }}>
            <div
              id="4"
              className="Home_Cards"
              style={{ borderRadius: "20px 0px 20px 0px" }}
            >
              <div className="Home_CardContent">
                <div className="Home_CardTitle">Step4</div>
                <div className="Home_CardDesc">
                  When you complete meal after 2 hrs you will need to enter your
                  post-blood glucose level.
                </div>
              </div>
              <div className="Home_CardImg">
                <img src={stepBg1} />
              </div>
            </div>
          </div>

          {/*
              <div
                id="1"
                className="Home_Cards"
                style={{ borderRadius: "0px 20px 0px 20px" }}
                data-aos="fate-left"
                data-aos-delay="300"
              >
                <div className="Home_CardContent">
                  <div className="Home_CardTitle">Step1</div>
                  <div className="Home_CardDesc">
                    Initially enter your pre-blood glucose level which you have got
                    in respected period
                  </div>
                </div>
                <div className="Home_CardImg">
                  <img src={stepBg1} />
                </div>
              </div>
  
            
              <div
                id="2"
                className="Home_Cards"
                style={{ borderRadius: "20px 0px 20px 0px" }}
                data-aos="fate-right"
                data-aos-delay="300"
              >
                <div className="Home_CardContent">
                  <div className="Home_CardTitle">Step2</div>
                  <div className="Home_CardDesc">
                    We will suggest low carbs food which you can select as meal as
                    well as you can also select your favorite food.
                  </div>
                </div>
                <div className="Home_CardImg">
                  <img src={stepBg2} />
                </div>
              </div>
  
              <div
                id="3"
                className="Home_Cards"
                style={{ borderRadius: "0px 20px 0px 20px" }}
              >
                <div className="Home_CardContent">
                  <div className="Home_CardTitle">Step3</div>
                  <div className="Home_CardDesc">
                    Depending upon the meal selected we will suggest you insulin
                    intake for that meal.
                  </div>
                </div>
                <div className="Home_CardImg">
                  <img src={stepBg3} />
                </div>
              </div>
  
              <div
                id="4"
                className="Home_Cards"
                style={{ borderRadius: "20px 0px 20px 0px" }}
              >
                <div className="Home_CardContent">
                  <div className="Home_CardTitle">Step4</div>
                  <div className="Home_CardDesc">
                    When you complete meal after 2 hrs you will need to enter your
                    post-blood glucose level.
                  </div>
                </div>
                <div className="Home_CardImg">
                  <img src={stepBg1} />
                </div>
              </div>
    */}
        </div>
      </div>
    );
  }
}
